import React, { Dispatch, ReactElement, SetStateAction } from 'react'

import { Box, Button, Typography } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'
import { GameType } from 'constants/enums/GameTypeEnum'

import arrowDown from 'assets/images/arrowDown.svg'
import arrowUp from 'assets/images/arrowUp.svg'

import { styles } from './GeneratedExampleDropdown.styles'
import { generatedExampleDropdownData } from './generatedExampleDropdownData'

export type Props = {
	currentResponses?: string[]
	customResponse?: ReactElement
	gameTypeEnum: GameType
	headerText: string
	isLoading?: boolean
	setShowAIExampleIdea: Dispatch<SetStateAction<boolean>>
	showAIExampleIdea: boolean
}

const TEST_ID = 'generated-example-dropdown'

export const GeneratedExampleDropdown = ({
	gameTypeEnum,
	headerText,
	currentResponses,
	customResponse,
	isLoading,
	showAIExampleIdea,
	setShowAIExampleIdea,
}: Props) => {
	const gameId = gameTypeEnum.value as number

	const gameHeroData = generatedExampleDropdownData[gameId]

	const olStyle = {
		background: gameHeroData.bg,
		paddingTop: 0,
		margin: 0,
	}

	const loadingElement = () => (
		<Box
			data-testid={`${TEST_ID}-loading`}
			display="flex"
			flexDirection="column"
			justifyItems="center"
			alignItems="center"
			sx={styles.loadingElementContainer}
		>
			<CircularProgress color="secondary" />
		</Box>
	)

	const buildResponseItem = (solution: string[]) => {
		return (
			<ol data-testid="gen-ai-sub-response-list" style={olStyle}>
				{solution.map((sol: string, idx: number) => (
					<Typography
						fontSize={16}
						color="black"
						component="li"
						key={`ai-sub-solution-${idx}`}
						sx={styles.solutionText}
						variant="body1"
					>
						{sol}
					</Typography>
				))}
			</ol>
		)
	}

	return (
		<Box>
			<Typography>{headerText}</Typography>
			<Box borderBottom={2} borderColor={gameHeroData.bg}>
				<Button
					fullWidth
					color="inherit"
					data-testid={`${TEST_ID}-show-ai-example-button`}
					onClick={() => setShowAIExampleIdea(!showAIExampleIdea)}
					sx={styles.aiButton}
				>
					<Box
						display={'flex'}
						justifyContent="space-between"
						width="100%"
					>
						<Typography sx={styles.typography}>
							View AI-Generated Example Ideas
						</Typography>
						<img
							alt="arrow"
							data-testid={`${TEST_ID}-arrow`}
							src={
								(showAIExampleIdea
									? arrowUp
									: arrowDown) as unknown as string
							}
						/>
					</Box>
				</Button>
			</Box>

			{showAIExampleIdea &&
				(isLoading
					? loadingElement()
					: currentResponses?.length && !customResponse
						? buildResponseItem(currentResponses)
						: customResponse)}
		</Box>
	)
}
